import { Image } from '@chakra-ui/react';
import React from 'react';
import logo from '@/assets/fiestabet/images/sideNav/logo.png';

export default function Index() {
  return <Image src={logo} maxW="110px" ml="2" pt="0.5" />;
}
